/** Bump when a full schema reset is required (stored in SQLite `PRAGMA user_version`). */
export const LATEST_SCHEMA_VERSION = 1;

export const OUTBOX_TABLE_NAME = 'SyncOfflineData';
